import { ky } from './client'

/**
 * Updates a plan nominaton.
 */
export const updateNomination = ({ planId, assignmentId }) => {
  return ky.put(`moderation/nominate/${planId}/${assignmentId}`).json()
}
